import React from 'react';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';

import StoryBadge from '../../../../../components/story-badge/StoryBadge';

function RatioBadge({ ratio }) {
  return <StoryBadge icon={AspectRatioOutlinedIcon} label={ratio} />;
}

export default RatioBadge;
